import styled from "styled-components";

type ContainerProps = {
  isDarkMode: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  background-position: right;
  background-repeat: no-repeat;
  position: relative;

  @media (min-width: 75rem) {
    background-image: ${(props) =>
    props.isDarkMode ? 'url(assets/images/grid-template-dark.svg)' : 'url(assets/images/grid-template.svg)'};
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: var(--color-white);
    clip-path: polygon(0 100%, 100% 0, 100% 100%);
  }

  @media (max-width: 75rem) {
    flex-direction: column;
    padding: 1rem;
    background-position: center;
    background-image: none;
  }
  @media (max-width: 48rem) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  max-width: 50%;
  padding: 1rem;
  z-index: 1;

  @media (max-width: 75rem) {
    max-width: 100%;
  }

  @media (max-width: 48rem) {
    align-items: center;
    text-align: center;
  }
`;

export const Image = styled.img`
  max-width: 40%;
  z-index: 10;

  @media (max-width: 48rem) {
    max-width: 80%;
    top: 0;
    margin-top: 2rem;
  }
`;

export const StyledHeading = styled.h2`
  @media (max-width: 48rem) {
    font-size: 2rem;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  @media (max-width: 75rem) {
    justify-content: flex-start;
    margin-bottom: 4rem;
  }
  @media (max-width: 48rem) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;
